"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageAssignmentCache = void 0;
const js_client_sdk_common_1 = require("@eppo/js-client-sdk-common");
const local_storage_1 = require("./local-storage");
class LocalStorageAssignmentShim {
    constructor() {
        this.LOCAL_STORAGE_KEY = 'EPPO_LOCAL_STORAGE_ASSIGNMENT_CACHE';
    }
    has(key) {
        if (!(0, local_storage_1.hasWindowLocalStorage)()) {
            return false;
        }
        return this.getCache().has(key);
    }
    get(key) {
        if (!(0, local_storage_1.hasWindowLocalStorage)()) {
            return null;
        }
        return this.getCache().get(key);
    }
    set(key, value) {
        if (!(0, local_storage_1.hasWindowLocalStorage)()) {
            return;
        }
        const cache = this.getCache();
        cache.set(key, value);
        this.setCache(cache);
    }
    getCache() {
        const cache = window.localStorage.getItem(this.LOCAL_STORAGE_KEY);
        return cache ? new Map(JSON.parse(cache)) : new Map();
    }
    setCache(cache) {
        window.localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(Array.from(cache.entries())));
    }
}
class LocalStorageAssignmentCache extends js_client_sdk_common_1.AssignmentCache {
    constructor() {
        super(new LocalStorageAssignmentShim());
    }
}
exports.LocalStorageAssignmentCache = LocalStorageAssignmentCache;
//# sourceMappingURL=local-storage-assignment-cache.js.map